import { ref } from 'vue'
import type { OutcomeCreationSource } from '../types'

// Global outcome-chooser state. The dialog itself is mounted once in
// AuthenticatedLayout so it survives callers that unmount themselves —
// notably the command palette, which is v-if'd away the moment it closes.
const visible = ref(false)
const source = ref<OutcomeCreationSource>('sidebar')
const selectedWizardId = ref<string | null>(null)

export const useOutcomeChooser = () => {
  const open = (fromSource: OutcomeCreationSource, wizardId: string | null = null) => {
    source.value = fromSource
    selectedWizardId.value = wizardId
    visible.value = true
  }

  const close = () => {
    visible.value = false
    selectedWizardId.value = null
  }

  return { visible, source, selectedWizardId, open, close }
}
